import ejs from 'ejs';
import moment from 'moment';

export default function currentYear() {
	const $containers = $('.js-years-list');

	if ( $containers.length ) {
		const template = ejs.compile($('#check-template').html(), {});
		const currentYear = moment().format('YYYY');

		$containers.each(function() {
			const $this = $(this);
			const firstYear = $this.data('first-year');

			for (let i = 0; i < Number(currentYear) - Number(firstYear) + 1; i++) {
				const $html = $(template({
					year: Number(firstYear) + i
				}));

				$this.append($html);
			}
		});
	}
}
